import { z } from 'zod';

/** Renderer to main: the backend the cached profile chose, sent each time it changes */
export const BACKEND_CHOICE_SET_CHANNEL = 'backend-choice:set';

/** Renderer asks main for its current choice, before the renderer sends its own */
export const BACKEND_CHOICE_GET_CHANNEL = 'backend-choice:get';

/** Main to every renderer: main's choice changed, from its own profile fetch, a window or sign-out */
export const BACKEND_CHOICE_CHANGED_CHANNEL = 'backend-choice:changed';

const BACKEND_CHOICES = ['python', 'typescript'] as const;

/**
 * The backend that serves a user, from the profile's `backend_choice`. Older
 * servers omit it, and this build reads a value it does not know as Python,
 * which serves every user who has not chosen otherwise
 */
export const BackendChoiceSchema = z.enum(BACKEND_CHOICES).catch('python');
export type BackendChoice = z.infer<typeof BackendChoiceSchema>;

export const BackendChoicePayloadSchema = z.object({
  backendChoice: z.enum(BACKEND_CHOICES),
});

/**
 * The headers that send a request to the user's backend. The load balancer
 * sends a request that carries `x-lb-backend: ts` to TypeScript; a request
 * without it goes to Python
 */
export const backendRoutingHeaders = (
  choice: BackendChoice | undefined
): Record<string, string> =>
  choice === 'typescript' ? { 'x-lb-backend': 'ts' } : {};
